<section class="app-pill-con-bar">
  <div class="app-pill-con-bar__con">
    <h2 class="app-pill-con-bar__con__txt">
      <b>Chcesz skorzystać z naszych wyjątkowych benefitów?</b> Zrób krok ku lepszemu rozwojowi swojego biznesu i
      skontaktuj się z nami lub Business Partnerem.
    </h2>
    <a
      [routerLink]="['/', wwwRouteSlug.CONTACT]"
      class="app-pill-con-bar__con__btn"
      appGtmClick
      [layer]="{
        event: 'uaevent',
        ecommerce: 'undefined',
        eventCategory: 'pillars page',
        eventAction: 'select::contact us',
        eventLabel: 'go to contact page::' + '/' + wwwRouteSlug.CONTACT,
        event_name: 'body_button_click',
        module_name: 'contact us',
        cta_name: 'go to contact page',
        link_url: '/' + wwwRouteSlug.CONTACT,
      }"
      >Kontakt ></a
    >
  </div>
</section>
